import { Toast } from '../Toast/Toast';

export const BrowserToast = () => {
  return (
    <Toast
      severity="warning"
      title="Use Google Chrome for the best experience"
      description="Other browsers are not fully supported and may have unexpected issues"
      position="top"
    />
  );
};
